import { API } from "./API";

export const FirmReportAPI = {
  GetFirmList: async (groupId) => {

    let data = JSON.stringify({
      requestValue: {
        groupId: groupId
      },
    })

    return await API.post(`FirmReport/GetFirmList`, data);
  },

  GetUserGroupRelatedLoginName: async (groupId) => {

    let data = JSON.stringify({
      requestValue: {
        groupId: groupId
      },
    })

    return await API.post(`PhoneSearch/GetUserGroupRelatedLoginName`, data);
  },
  GetUserEuIdByLoginName: async (loginName) => {
    let data = JSON.stringify({
      requestValue: {
        loginName: loginName
      },
    });

    return await API.post(`SendingReport/GetUserEuIdByLoginName`, data);
  },
};